import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthChange, getAdminData, getBeach, getTariffe } from '../services/firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [admin, setAdmin]     = useState(null);
  const [beach, setBeach]     = useState(null);
  const [tariffe, setTariffe] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthChange(async (firebaseUser) => {
      if (firebaseUser) {
        const adminData = await getAdminData(firebaseUser.uid);
        if (adminData) {
          const [beachData, tariffaData] = await Promise.all([
            getBeach(adminData.beachCode),
            getTariffe(adminData.beachCode),
          ]);
          setUser(firebaseUser);
          setAdmin(adminData);
          setBeach(beachData);
          setTariffe(tariffaData);
        } else {
          setUser(null); setAdmin(null); setBeach(null); setTariffe([]);
        }
      } else {
        setUser(null); setAdmin(null); setBeach(null); setTariffe([]);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const refreshBeach = async () => {
    if (!admin?.beachCode) return;
    const [beachData, tariffaData] = await Promise.all([
      getBeach(admin.beachCode),
      getTariffe(admin.beachCode),
    ]);
    setBeach(beachData);
    setTariffe(tariffaData);
  };

  const needsOnboarding = admin && !admin.onboardingCompleto;

  return (
    <AuthContext.Provider value={{ user, admin, beach, tariffe, loading, needsOnboarding, refreshBeach }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
